import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-layout" }
const _hoisted_2 = { class: "app-layout__content" }
const _hoisted_3 = { class: "app-main app-main--expanded" }
const _hoisted_4 = { class: "app-main__container" }
const _hoisted_5 = { class: "app-footer" }
const _hoisted_6 = { class: "app-footer__content" }
const _hoisted_7 = { class: "app-footer__links" }
const _hoisted_8 = { class: "app-footer__copyright" }

import { computed } from 'vue';
// @ts-ignore
import TopBar from '../TopBar.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {

/// <reference types="vue" />
const currentYear = computed(() => new Date().getFullYear());

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopBar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, { to: "/privacy-policy" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('legal.privacyPolicy')), 1)
            ]),
            _: 1
          }),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "separator" }, "|", -1)),
          _createVNode(_component_router_link, { to: "/cookie-policy" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('legal.cookiePolicy')), 1)
            ]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "separator" }, "|", -1)),
          _createVNode(_component_router_link, { to: "/terms-of-service" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('legal.termsOfService')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, " © " + _toDisplayString(currentYear.value) + " Bati Vision 360. " + _toDisplayString(_ctx.$t('legal.footer.allRightsReserved')), 1)
      ])
    ])
  ]))
}
}

})